const normalize = (value: unknown, fallback: string) => {
  if (typeof value !== 'string') return fallback
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : fallback
}

const appVersion = normalize(
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : import.meta.env.VITE_APP_VERSION,
  '0.0.0',
)
const gitSha = normalize(
  typeof __APP_GIT_SHA__ !== 'undefined' ? __APP_GIT_SHA__ : import.meta.env.VITE_GIT_SHA,
  'local',
)
const buildTimeISO = normalize(
  typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : import.meta.env.VITE_BUILD_TIME,
  'unknown',
)
const appEnv = normalize(
  typeof __APP_ENV__ !== 'undefined' ? __APP_ENV__ : import.meta.env.MODE,
  'unknown',
)

const shortGitSha = gitSha === 'local' ? gitSha : gitSha.slice(0, 8)
const versionLabel = `v${appVersion}`
const displayVersion = shortGitSha ? `${versionLabel} (${shortGitSha})` : versionLabel

export const buildInfo = {
  appVersion,
  gitSha,
  shortGitSha,
  buildTimeISO,
  appEnv,
  versionLabel,
  displayVersion,
}

export const buildInfoCopyText = [
  `web_version=${appVersion}`,
  `git_sha=${gitSha}`,
  `build_time=${buildTimeISO}`,
  `env=${appEnv}`,
].join('\n')
